import React, { useRef, useEffect, useImperativeHandle, useState } from "react";
import { ScrollView, TouchableOpacity } from "react-native";
import {
  Text,
  Box,
  Button,
  Flex,
  Center,
  Avatar,
  VStack,
  Image,
  AspectRatio,
  useColorMode,
  useColorModeValue,
} from "native-base";

import { CommonActions, useNavigation } from "@react-navigation/native";
import { StackNavigationProp } from "@react-navigation/stack";

import createStyles from "./styles";

import Modal from "../../components/ModalPersonalizado";
import { RFPercentage } from "react-native-responsive-fontsize";
import { useTheme } from "../../ThemeProvider.tsx";
import Loader from "../../components/Loader";
import ModalConfirmacao from "../../components/ModalConfirmacao";
import { AntDesign, Entypo } from "@expo/vector-icons";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import {
  heightPercentageToDP,
  widthPercentageToDP,
} from "react-native-responsive-screen";
import Menu from "../pages/Inicio/Layout2/Menu/Index";
import { TitleItem } from "../components/Title/Index";
import Alerta from "../components/Alerta/Index";

interface Props {
  titulo: string;
  messageAlerta?: string;
  urlLogo?: string;
  exibeLogo?: boolean;
  exibeMenuSuperior?: boolean;
  titulo_botao_proximo?: string;
  titulo_botao_voltar?: string;
  icon_voltar?: string;
  textoCentroFooter?: string;
  disabled_button_proximo?: boolean;
  ocultarBotaoCancelar?: boolean;
  onBotaoProximoClick?: () => void;
  /**
   * Função chamada quando o botão "Próximo" é clicado.
   * @param id O ID associado ao botão.
   * @returns Verdadeiro se a ação foi bem sucedida, falso caso contrário.
   */
  onBotaoVoltarClick?: () => void;
  children?: React.ReactNode;
  filtro?: React.ReactNode;
  escondeBotoesRodape?: boolean;
  abrirModal?: boolean;
  semBotaoProximo?: boolean;
  semBotaoVoltar?: boolean;
}

interface BotoesRodapeProps {
  onBotaoVoltarClick?: () => void;
  onBotaoProximoClick?: () => void;
  titulo_botao_proximo?: string;
  titulo_botao_voltar?: string;
  icon_voltar?: string;
  textoCentroFooter?: string;
  disabled_button_proximo?: boolean;
  semBotaoProximo?: boolean;
  semBotaoVoltar?: boolean;
}

function Template(
  {
    titulo,
    urlLogo,
    exibeLogo,
    exibeMenuSuperior,
    titulo_botao_proximo,
    titulo_botao_voltar,
    messageAlerta,
    icon_voltar,
    textoCentroFooter,
    onBotaoProximoClick,
    onBotaoVoltarClick,
    children,
    filtro,
    escondeBotoesRodape,
    disabled_button_proximo,
    semBotaoProximo,
    semBotaoVoltar,
    ocultarBotaoCancelar,
  }: Props,
  ref: any,
) {
  const {
    primaryColor,
    cor_rgba,
    isMobile,
    fontSizeMobile,
    fontSizeDesktop,
    configEmpresa,
  } = useTheme();

  const refModal = useRef<any>(null); // Certifique-se de que a inicialização está correta
  const refLoader = useRef();
  const [tituloModal, setTituloModal] = useState<string>("Atenção");
  const [textoModal, setTextoModal] = useState<string>("");
  const [abrirLoader, setAbrirLoader] = useState<boolean>(false);
  const [getConfigEmpresa, setConfigEmpresa] = useState<any>(
    JSON.parse(configEmpresa),
  );

  const styles = createStyles(getConfigEmpresa.coresPWA); // gere os estilos dinâmicos
  const navigation = useNavigation<StackNavigationProp<any>>();

  const getIconByTitle = (title: string) => {
    const titleLower = title.toLowerCase();

    if (titleLower.includes("serviço") || titleLower.includes("servico")) {
      return "scissors-cutting";
    } else if (titleLower.includes("profissional")) {
      return "account-tie";
    } else if (titleLower.includes("dia")) {
      return "calendar";
    } else if (
      titleLower.includes("horário") ||
      titleLower.includes("horario")
    ) {
      return "clock-outline";
    } else if (titleLower.includes("dados")) {
      return "database";
    } else if (titleLower.includes("agendamento")) {
      return "calendar-check";
    } else if (titleLower.includes("comprovante")) {
      return "file-document";
    } else if (titleLower.includes("cliente")) {
      return "account-group";
    } else if (
      titleLower.includes("pacote") ||
      titleLower.includes("pacotes")
    ) {
      return "package-variant";
    } else if (titleLower.includes("produto")) {
      return "shopping";
    } else if (titleLower.includes("perfil") || titleLower.includes("conta")) {
      return "account";
    } else if (
      titleLower.includes("histórico") ||
      titleLower.includes("historico")
    ) {
      return "history";
    } else if (
      titleLower.includes("configuração") ||
      titleLower.includes("configuracao")
    ) {
      return "cog";
    } else if (
      titleLower.includes("contato") ||
      titleLower.includes("fale conosco")
    ) {
      return "phone";
    } else if (titleLower.includes("sobre")) {
      return "information";
    } else if (titleLower.includes("assinatura")) {
      return "credit-card";
    } else {
      return "format-title"; // ícone padrão
    }
  };

  function BotoesRodape({
    onBotaoVoltarClick,
    onBotaoProximoClick,
    titulo_botao_proximo,
    titulo_botao_voltar,
    icon_voltar,
    textoCentroFooter,
    disabled_button_proximo,
    semBotaoProximo,
    semBotaoVoltar,
  }: BotoesRodapeProps) {
    return (
      <Flex
        style={[
          styles.flexContainer,
          {
            justifyContent:
              !semBotaoVoltar && !semBotaoProximo
                ? "space-between"
                : "space-between",
          },
        ]}
      >
        {/* <Button  */}
        {!semBotaoVoltar && (
          <TouchableOpacity
            onPress={() => {
              onBotaoVoltarClick ? onBotaoVoltarClick() : navigation.goBack();
            }}
            style={[styles.button, { backgroundColor: "#6D6D6D" }]}
          >
            <Entypo
              name={icon_voltar ? icon_voltar : "arrow-with-circle-left"}
              size={18}
              color="#fff"
              style={{ marginRight: 4 }}
            />
            <Text style={styles.buttonText} fontSize="md" fontWeight="bold">
              {titulo_botao_voltar ? titulo_botao_voltar : "Voltar"}
            </Text>
          </TouchableOpacity>
        )}

        {textoCentroFooter && (
          <Text
            style={[styles.textFooter, { fontWeight: "500" }]}
            fontSize="md"
          >
            <strong>{textoCentroFooter}</strong>
          </Text>
        )}
        {/* alterado fonte */}

        {!semBotaoProximo && (
          <TouchableOpacity
            disabled={disabled_button_proximo}
            onPress={onBotaoProximoClick}
            style={[
              styles.button,
              {
                backgroundColor: disabled_button_proximo
                  ? (cor_rgba ?? "defaultColor")
                  : (primaryColor ?? "defaultColor"),
              },
            ]}
          >
            <Text style={styles.buttonText} fontSize="md" fontWeight="bold">
              {titulo_botao_proximo || "Próximo"}
            </Text>

            {titulo_botao_proximo == "Agendar" ? (
              <MaterialCommunityIcons
                name="check-circle-outline"
                size={18}
                color="#fff"
                style={{ marginLeft: 4 }}
              />
            ) : (
              <Entypo
                name="arrow-with-circle-right"
                size={18}
                color="#fff"
                style={{ marginLeft: 4 }}
              />
            )}
          </TouchableOpacity>
        )}
      </Flex>
    );
  }

  useImperativeHandle(ref, () => ({
    abrirModal(mensagem: string, titulo: string) {
      setTituloModal(titulo ? titulo : "Atenção");
      setTextoModal(mensagem);
      refModal.current.abrirModal();
    },
    fecharModal() {
      refModal.current.fecharModal();
    },
    abrirLoader() {
      setAbrirLoader(true);
      // refLoader.current.abrirLoader();
    },
    fecharLoader() {
      setAbrirLoader(false);
      // refLoader.current.fecharLoader();
    },
  }));

  return (
    <Box style={styles.boxGeral}>
      {/* <Button onPress={toggleColorMode}>Toggle</Button> */}

      {exibeLogo ? (
        <Box style={styles.boxBanner}>
          <Image
            alt="Imagem de fundo do banner"
            source={{ uri: urlLogo || "" }}
            style={{ width: widthPercentageToDP("100%"), height: "100%" }}
            resizeMode="cover"
          />
        </Box>
      ) : null}

      {exibeMenuSuperior ? <Menu /> : null}

      <Box
        style={[
          styles.header,
          {
            backgroundColor:
              getConfigEmpresa.coresPWA.corFundoHeaderAreaCliente || "#fff",
            paddingVertical: 15,
            paddingHorizontal: 20,
            borderBottomLeftRadius: 20,
            borderBottomRightRadius: 20,
            shadowColor: "#000",
            shadowOffset: {
              width: 0,
              height: 2,
            },
            shadowOpacity: 0.1,
            shadowRadius: 3,
            elevation: 3,
            borderWidth: 1,
            borderColor: getConfigEmpresa.coresPWA.corBordaPrimaria || "#000",
          },
        ]}
      >
        <Flex
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          width="100%"
        >
          <Flex direction="row" alignItems="center" style={{ gap: 8 }}>
            <MaterialCommunityIcons
              name={getIconByTitle(titulo) as any}
              size={24}
              color={
                getConfigEmpresa.coresPWA.corFonteHeaderAreaCliente || "#000"
              }
            />
            <Text
              style={[
                styles.tituloHeader,
                {
                  fontSize: 16,
                  fontWeight: "bold",
                  color:
                    getConfigEmpresa.coresPWA.corFonteHeaderAreaCliente ||
                    "#000",
                },
              ]}
            >
              {titulo}
            </Text>
          </Flex>
          {!ocultarBotaoCancelar && (
            <TouchableOpacity
              onPress={() =>
                navigation.dispatch(
                  CommonActions.reset({
                    index: 0,
                    routes: [
                      { name: "TabNavigator", params: { screen: "Inicio" } },
                    ],
                  }),
                )
              }
              style={{
                borderRadius: 20,
                borderColor:
                  getConfigEmpresa.coresPWA.corFonteHeaderAreaCliente || "#000",
                borderWidth: 1,
              }}
            >
              <MaterialCommunityIcons
                name="close"
                size={20}
                color={
                  getConfigEmpresa.coresPWA.corFonteHeaderAreaCliente || "#000"
                }
                style={{
                  padding: 8,
                  backgroundColor: "#dc3545",
                  borderRadius: 20,
                }}
              />
            </TouchableOpacity>
          )}
        </Flex>
      </Box>

      {messageAlerta && (
        <Alerta
          message={messageAlerta}
          status="info"
          coresPWA={getConfigEmpresa.coresPWA}
        />
      )}

      {filtro ? (
        <Box style={styles.boxGeralScrollViewFiltro}>{filtro}</Box>
      ) : null}

      <ScrollView>
        <Box style={styles.boxGeralScrollView}>
          <Box
            style={[
              styles.boxGeralScrollViewBox,
              { height: heightPercentageToDP("100%") },
            ]}
          >
            {children}
          </Box>
        </Box>
      </ScrollView>
      {escondeBotoesRodape ? null : (
        <BotoesRodape
          onBotaoVoltarClick={onBotaoVoltarClick}
          onBotaoProximoClick={onBotaoProximoClick}
          titulo_botao_proximo={titulo_botao_proximo}
          titulo_botao_voltar={titulo_botao_voltar}
          icon_voltar={icon_voltar}
          textoCentroFooter={textoCentroFooter}
          disabled_button_proximo={disabled_button_proximo}
          semBotaoProximo={semBotaoProximo}
          semBotaoVoltar={semBotaoVoltar}
        />
      )}

      <ModalConfirmacao
        titulo={tituloModal}
        ref={refModal}
        mensagem={textoModal}
        textoBotaoPositivo={"OK"}
        onConfirmPositivo={() => {
          if (refModal.current) {
            refModal.current.fecharModal();
          }
        }}
      />

      {abrirLoader && <Loader ref={refLoader} />}
    </Box>
  );
}

export default React.forwardRef(Template);
